const HomePage = () => null;

export default HomePage;
